module.exports = __webpack_public_path__ + "img/cheyibao-icon.3a2ce0aa.png";